class Toast extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    trapFocus(this);
    this.querySelector('.close').addEventListener('click', (ev) => {
      this.close();
    });
    this.addEventListener('custom:escape', (ev) => {
      this.close();
    });
  }

  close() {
    window.dispatchEvent(new CustomEvent('custom:toast:close'));
    releaseFocus(this);
    this.remove();
  }
}

customElements.define('toast-message', Toast);
